import React from 'react';

import { Tooltip } from 'antd';

const SummaryCard = ({
  icon,
  title,
  value,
  status,
  statusValue,
  type,
  bgcIcon = 'green',
  contentTop = '',
  colorTop = 'orange',
  contentBottom = '',
  colorBottom = 'red',
}) => {
  return (
    <div className='summary-card'>
      <div className='summary-top'>
        <div className={`summary-icon ${bgcIcon}`}>{icon}</div>

        <div className='summary-content'>
          <div className='summary-title'>{title}</div>
        </div>
        <Tooltip title={contentTop} color={colorTop}>
          <div className='summary-value'>{value}</div>
        </Tooltip>
      </div>

      <div className='summary-bottom'>
        <span className='summary-desc'>{status}: </span>
        <Tooltip title={contentBottom} color={colorBottom} placement='bottom'>
          <span className={`summary-badge ${type}`}>{statusValue}</span>
        </Tooltip>
      </div>
    </div>
  );
};
export default SummaryCard;
